// Class: starling.events.TouchPhase

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var TouchPhase = function(){}

// Meta

TouchPhase.__name__ = "starling.events.TouchPhase";
TouchPhase.__isInterface__ = false;
TouchPhase.prototype = {
	
};
TouchPhase.prototype.__class__ = TouchPhase.prototype.constructor = $hxClasses["starling.events.TouchPhase"] = TouchPhase;

// Init



// Statics


TouchPhase.HOVER = "hover"
TouchPhase.BEGAN = "began"
TouchPhase.MOVED = "moved"
TouchPhase.STATIONARY = "stationary"
TouchPhase.ENDED = "ended"

// Export

exports.default = TouchPhase;